const getDefaultResizeObserverClass = () =>
  typeof ResizeObserver !== 'undefined' ? ResizeObserver : null;

const createSafeResizeObserver = (
  callback,
  ResizeObserverClass = getDefaultResizeObserverClass()
) => {
  if (
    typeof callback !== 'function' ||
    typeof ResizeObserverClass !== 'function'
  ) {
    return null;
  }

  try {
    return new ResizeObserverClass(callback);
  } catch (_) {
    return null;
  }
};

const observeSafeResizeObserver = (observer = null, element = null) => {
  if (!element || typeof observer?.observe !== 'function') {
    return false;
  }

  try {
    observer.observe(element);
    return true;
  } catch (_) {
    return false;
  }
};

const unobserveSafeResizeObserver = (observer = null, element = null) => {
  if (!element || typeof observer?.unobserve !== 'function') {
    return false;
  }

  try {
    observer.unobserve(element);
    return true;
  } catch (_) {
    return false;
  }
};

const disconnectSafeResizeObserver = (observer = null) => {
  if (typeof observer?.disconnect !== 'function') {
    return false;
  }

  try {
    observer.disconnect();
    return true;
  } catch (_) {
    return false;
  }
};

export {
  createSafeResizeObserver,
  disconnectSafeResizeObserver,
  observeSafeResizeObserver,
  unobserveSafeResizeObserver,
};
